import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { jobServices } from '../../services/jobServices';

export const fetchJobStatusData = createAsyncThunk(
  'jobStatus/fetchJobStatusData',
  async (accessToken, { rejectWithValue }) => {
    try {
      const response = await jobServices.getJobStatus(accessToken);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const jobStatusSlice = createSlice({
  name: 'jobStatus',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobStatusData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchJobStatusData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = Object.entries(action.payload)
          .map(([key, value]) => ({ value: key, label: value }));
      })
      .addCase(fetchJobStatusData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default jobStatusSlice.reducer;
